import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { getConfigFromRouterContext } from './getRequiredResourceList.tsx';

type BoardDetails = {
	id: number;
	location?: {
		name: string;
		displayName: string;
		avatarURI: string;
		projectId?: number;
		projectKey?: string;
		projectName?: string;
		projectTypeKey?: string;
		userAccountId?: string;
		userId?: number;
	};
	name: string;
	self: string;
	type: string;
};

const getBoardDetails = async (boardId: string): Promise<BoardDetails | null> => {
	try {
		return await fetchJson(`/rest/agile/1.0/board/${boardId}`);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getBoardDetailsRequest',
				packageName: 'jiraRouterResourcesClassicProjects',

				teamName: 'a4t-pandora',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};

// Used for fetching during SSR
export const boardDetailsResource: RouteResource<BoardDetails | null> =
	createResource<BoardDetails | null>({
		type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
		getKey: (routerContext) =>
			getConfigFromRouterContext(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
		getData: async (routerContext) => {
			const boardId = routerContext.match.params?.boardId ?? '';
			if (getConfigFromRouterContext(routerContext)) {
				return getBoardDetails(boardId);
			}
			return null;
		},
	});

export const getBoardDetailsResource = (): RouteResource<BoardDetails | null> =>
	boardDetailsResource;
